import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useState, useRef, useEffect } from "react";
import { useIntersection } from "react-use";
import { analytics } from "@silvertours/front-entities";
import Close from "@engineering/icons/close";
import { Ui } from "@silvertours/front-shared";
import { Wrapper, CloseButton } from "./InfoBanner.styles";
var InfoBanner = function(param) {
    var closable = param.closable, sticky = param.sticky, theme = param.theme, content = param.content;
    var ref = useState(true), isInfoBannerVisible = ref[0], setInfobannerVisible = ref[1];
    var intersectionRef = useRef(null);
    var intersection = useIntersection(intersectionRef, {
        root: null,
        rootMargin: "0px",
        threshold: 1
    });
    useEffect(function() {
        var banner = document.getElementById("infobanner");
        var links = banner === null || banner === void 0 ? void 0 : banner.getElementsByTagName("a");
        if (links) {
            var linkList = [].slice.call(links);
            linkList.forEach(function(link) {
                var anchor = link;
                var label = anchor.pathname.replace(/^\/|\/$/g, "");
                anchor.onclick = function() {
                    return analytics.gtm.trackInfoBannerLinkClicked(label);
                };
            });
        }
    }, []);
    var onClose = function() {
        setInfobannerVisible(false);
        analytics.gtm.trackInfoBannerCloseClicked();
    };
    return /*#__PURE__*/ _jsx("div", {
        ref: intersectionRef,
        children: isInfoBannerVisible && /*#__PURE__*/ _jsxs(Wrapper, {
            isIntersecting: sticky && Boolean(intersection && intersection.intersectionRatio < 1),
            className: theme,
            id: "infobanner",
            children: [
                /*#__PURE__*/ _jsx(Ui.RichText, {
                    content: content
                }),
                closable && /*#__PURE__*/ _jsx(CloseButton, {
                    icon: Close,
                    title: "close" // @TODO: Add translation
                    ,
                    onClick: onClose
                })
            ]
        })
    });
};
export { InfoBanner };
